// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-close-container {
    max-height: 30rem;
    overflow: auto;
}

.chat-close-body {
    margin-left: 1rem;
    width: 90%;
}

.chat__close-reason-container {
    width: 700px;
    top: 45%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    max-width: none;
}

.close-reason-container__question {
    color: black;
}

.chat__close-reason-container .modal-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    font-size: 2.6rem;
}

.close-reason-container__button {
    width: 130px;
    margin: 0px 10px 0px 10px !important;
}

.close-reason-container__select {
    margin: 20px 0px 20px 0px;
}

.close-reason-container_spinner {
    margin-left: auto;
    margin-right: auto;
    display: table;
}

.close-reason-container__checkbox {
    margin-top: 1rem;
    text-align: left;
}

.close-reason-container__checkbox-label {
    display: flex;
    align-items: center;
    color: black;
}
    .close-reason-container__checkbox-label input[type="checkbox"] + span {
        font-size: 1.4rem;
    }`, "",{"version":3,"sources":["webpack://./src/app/chat/specify-chat-close-reason-dialog/SpecifyChatCloseReasonDialog.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,+BAA+B;IAC/B,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;IACI;QACI,iBAAiB;IACrB","sourcesContent":[".chat-close-container {\r\n    max-height: 30rem;\r\n    overflow: auto;\r\n}\r\n\r\n.chat-close-body {\r\n    margin-left: 1rem;\r\n    width: 90%;\r\n}\r\n\r\n.chat__close-reason-container {\r\n    width: 700px;\r\n    top: 45%;\r\n    -ms-transform: translateY(-50%);\r\n    transform: translateY(-50%);\r\n    max-width: none;\r\n}\r\n\r\n.close-reason-container__question {\r\n    color: black;\r\n}\r\n\r\n.chat__close-reason-container .modal-title {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin: 0;\r\n    font-size: 2.6rem;\r\n}\r\n\r\n.close-reason-container__button {\r\n    width: 130px;\r\n    margin: 0px 10px 0px 10px !important;\r\n}\r\n\r\n.close-reason-container__select {\r\n    margin: 20px 0px 20px 0px;\r\n}\r\n\r\n.close-reason-container_spinner {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    display: table;\r\n}\r\n\r\n.close-reason-container__checkbox {\r\n    margin-top: 1rem;\r\n    text-align: left;\r\n}\r\n\r\n.close-reason-container__checkbox-label {\r\n    display: flex;\r\n    align-items: center;\r\n    color: black;\r\n}\r\n    .close-reason-container__checkbox-label input[type=\"checkbox\"] + span {\r\n        font-size: 1.4rem;\r\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
